import React, { useState } from "react";
import  "../styles/About.css";
import "../styles/Carousel.css"
function About() {
    React.useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, []);
    // Slides pueden ser imágenes o un video
    const slides = [
        {   
            type: "video",
            src: "https://doinaro28web.s3.eu-central-1.amazonaws.com/videos/eventoVideo.mp4", // Cambia esto a la ruta correcta de tu video de 10 segundos
            poster: "/images/evento4_poster.jpg", // Opcional: imagen de portada para el video
        },
        { type: "image", src: "/images/carousel1.jpg" },
        { type: "image", src: "/images/carousel2.jpg" },


    ];

    function Carousel() {
        const [index, setIndex] = useState(0);
        const [lightboxOpen, setLightboxOpen] = useState(false);
        const [lightboxSrc, setLightboxSrc] = useState("");
        const total = slides.length;

        // Auto-avance desactivado

        const handlePrev = () => {
            setIndex((prev) => (prev - 1 + total) % total);
        };
        const handleNext = () => {
            setIndex((prev) => (prev + 1) % total);
        };

        return (
            <>
            <div className="carousel" style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                margin: "20px 0",
                width: "100%",
                maxWidth: "600px",
                height: "380px"
            }}>
                <button
                    aria-label="Anterior"
                    className="carousel-arrow carousel-arrow-left"
                    onClick={handlePrev}
                    style={{
                        background: "none",
                        border: "none",
                        fontSize: "2rem",
                        cursor: "pointer",
                        color: "#444"
                    }}
                >
                    &#8592;
                </button>
                <div
                    className="carousel-slide"
                    style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                        borderRadius: "12px",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.08)"
                    }}
                >
                    {slides[index].type === "image" ? (
                        <img
                            src={slides[index].src}
                            alt={`Evento especial ${index + 1}`}
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                cursor: "pointer"
                            }}
                            onClick={() => { setLightboxSrc(slides[index].src); setLightboxOpen(true); }}
                        />
                    ) : (
                        <video
                            src={slides[index].src}
                            controls
                            poster={slides[index].poster}
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover"
                            }}
                            autoPlay
                            loop
                            muted
                        />
                    )}
                </div>
                <button
                    aria-label="Siguiente"
                    className="carousel-arrow carousel-arrow-right"
                    onClick={handleNext}
                    style={{
                        background: "none",
                        border: "none",
                        fontSize: "2rem",
                        cursor: "pointer",
                        color: "#444"
                    }}
                >
                    &#8594;
                </button>
            </div>
            {lightboxOpen && (
                <div 
                  className="lightbox-overlay" 
                  onClick={() => setLightboxOpen(false)} 
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    background: "rgba(0,0,0,0.8)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 9999
                  }}
                >
                  <img src={lightboxSrc} alt="Evento ampliado" style={{ maxWidth: "90%", maxHeight: "90%", borderRadius: "12px" }} />
                </div>
              )}
            </>
        );
    }

    return (
        <section className="about-section">
            <div className="about-container">
                {/* Imagen de la autora */}
                <div className="about-image-wrapper">
                    <img
                        src="/images/doina.png"
                        alt="Doina"
                        className="about-image"
                    />
                </div>

                {/* Texto + videos */}
                <div className="about-content">
                    <h2>Sobre mí</h2>
                    <p className="about-text">
                        Soy <strong>Doina</strong>, autora apasionada por las letras y las historias que inspiran.
                        Desde pequeña he transformado emociones en palabras y comparto mis experiencias a través de mis libros y proyectos multimedia.
                        Aquí podrás conocer más sobre mi trabajo, mis libros y contenidos especiales que he preparado para ti.
                    </p>

                    {/* Videos embebidos y carrusel lado a lado */}
                    <div className="about-videos-events responsive-videos-events" style={{ gap: "20px", alignItems: "flex-start" }}>
                        <div className="responsive-video-container">
                        <iframe
                            src="https://www.youtube.com/embed/ZgySht-Y2DY?start=2"
                            title="YouTube video 1"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            className="responsive-iframe"
                        ></iframe>
                        
                            <h3 className="about-events-title">Eventos Especiales</h3>
                            <h5 className="about-events-subtitle">Especial San Juan</h5>
                            <div className="responsive-carousel-container">
                              <Carousel />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;